import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Public (unauthenticated) layout for `/public/*` widget + chat routes. Lives
 * outside `_app`, so none of the session/auth providers mount here.
 */
export const Route = createFileRoute('/public')({
  component: PublicLayout,
});

function PublicLayout() {
  return (
    <div className="min-h-screen bg-background">
      <Outlet />
    </div>
  );
}
